<template>
  <!-- 底部导航 -->
  <div>
    <!-- 个人信息 -->
    <div class="personal-con">
      <!-- 最新消息 -->
      <div class="nav-menu">
        <!-- <div class="pack-up"
               @click="messageShow=false"><i class="el-icon-arrow-right"></i></div> -->
        <div class="box1">
          <div class="avatar">
            <img :src="!userInfo.headPortrait ? '/images/default_avatar.png' : userInfo.headPortrait" alt="">
          </div>
          <div class="right" v-if="!token">
            <div class="login">请先登录</div>
          </div>
          <div class="right" v-else>
            <span class="name">{{ !userInfo.nickName ? '昵称' : 'Hi,' + userInfo.nickName }}</span>
            <!-- <button class="btn" :style="'background-color:' + themeColor" @click="logOut">退出</button> -->
          </div>
        </div>
        <!-- 余额 -->
        <div class="money">
          <div class="box">
            <span class="txt2">{{ !userInfo.welfarePoint ? '0.00' : userInfo.welfarePoint }}</span>
            <span class="txt1">福利卡余额</span>
          </div>
          <div class="box">
            <span class="txt2">{{ !userInfo.assistancePoint ? '0.00' : userInfo.assistancePoint }}</span>
            <span class="txt1">助农卡余额</span>
          </div>
        </div>
        <div class="money-line"></div>
        <!-- 选项 -->
        <div class="other-box">
          <div class="other_item" @click.stop="jumpCenterPage(1)">
            <img src="/images/home_icon3.png" alt="">
            <div>个人中心</div>
          </div>
          <div class="other_item" @click.stop="jumpCenterPage(2)">
            <img src="/images/home_icon4.png" alt="">
            <div>我的订单</div>
          </div>
          <!-- <div class="other_item"
                 @click.stop="jumpCenterPage(3)">
              <img src="/images/home_icon2.png"
                   alt="">
              <div>福利卡</div>
            </div> -->
          <div class="other_item" @click.stop="jumpCenterPage(4)">
            <img src="/images/home_icon7.png" alt="">
            <div>消息通知</div>
          </div>
          <div class="other_item" @click.stop="jumpCenterPage(5)">
            <img src="/images/home_icon5.png" alt="">
            <div>我的收藏</div>
          </div>
          <div class="other_item" @click.stop="jumpCenterPage(6)">
            <img src="/images/home_icon6.png" alt="">
            <div>浏览记录</div>
          </div>
        </div>
        <div class="line"></div>
        <div class="box2">
          <div class="nav">
            <span class="nav-tit">最新公告</span>
            <div class="nav-more" style="display: flex;align-items: center;" @click="jumpNotice">
              <span>更多></span>
            </div>
          </div>
          <div class="center">
            <div class="message" v-for="(item, index1) in noticeList1" :key="index1" v-show="index1 == 0">
              <div class="word">{{ item.title }}</div>
              <img src="/images/new.png" alt="" />
            </div>
            <!-- <div class="message">
              <span class="word2"
                    v-for="(item,index2) in noticeList2"
                    :key="index2">{{ item.title }}</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserInfo',
  data() {
    return {
      userInfo: {},//个人信息
      noticeList1: [],//最新通知
      token: '',
    }
  },
  mounted() {
    this.token = localStorage.getItem('wckj-Token')
    if (localStorage.getItem('wckj-Token')) {
      // this.getActivity()
      this.getUserInfo()
    }
    this.getNotice()
  },
  methods: {
    // 获取最新公告
    async getNotice() {
      await this.$api.mall.getNotice({
        releasePc: 1
      }).then((res) => {
        console.log(res, '最新公告');
        if (res.code == 200) {
          let data = res.data
          if (data.lenth <= 3) {
            this.noticeList1 = data
          } else {
            data.forEach((item, index) => {
              if (index < 3) {
                this.noticeList1.push(item)
              } else {
                this.noticeList2.push(item)
              }
            })
          }
        }
      });
    },
    // 获取个人信息
    async getUserInfo() {
      await this.$api.mall.getInfo().then((res) => {
        console.log(res, '个人信息');
        if (res.code == 200) {
          this.userInfo = res.data.userInfo
        }
      });
    },
    jumpCenterPage(type) {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      if (type == 1) {
        this.$store.dispatch('saveMessageType', '')
        this.$store.dispatch('savePersonType', '')
        this.$router.push('/userInfo');
      } else if (type == 2) {
        this.$store.dispatch('savePersonType', 1)
        this.$store.dispatch('saveMessageType', '')
        this.$router.push('/orderList');
      } else if (type == 3) {
        this.$store.dispatch('savePersonType', 3)
        this.$store.dispatch('saveMessageType', '')
        this.$router.push('/benefitCard');
      } else if (type == 4) {
        this.$store.dispatch('saveMessageType', 1)
        this.$store.dispatch('savePersonType', '')
        this.$router.push('/messageList');
      } else if (type == 5) {
        this.$store.dispatch('savePersonType', 9)
        this.$store.dispatch('saveMessageType', '')
        this.$router.push('/collectRecord');
      } else if (type == 6) {
        this.$store.dispatch('savePersonType', 10)
        this.$store.dispatch('saveMessageType', '')
        this.$router.push('/browseRecord');
      }
    },
    // 跳转更多信息
    jumpNotice() {
      this.$router.push('/noticeList')
    },
  }
};
</script>

<style lang="scss" scoped>
.personal-con {
  height: 100%;
  background: #FFFFFF;
  border-radius: 0px 2px 2px 0px;
  margin-left: 9px;
  padding: 16px;
  box-sizing: border-box;

  .nav-menu {
    .pack-up {
      width: 25px;
      height: 50px;
      background-color: #fff;
      position: absolute;
      left: -25px;
      top: calc(50% - 25px);
      z-index: 5;
      font-size: 22px;
      border-radius: 30px 0 0 30px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .box1 {
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .avatar {
        width: 40px;
        height: 40px;
        border-radius: 100%;
        overflow: hidden;

        img {
          width: 40px;
          height: 40px;
          display: inline-block;
        }
      }

      .right {
        flex: 1;
        height: 54px;
        padding-left: 12px;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .name {
          width: 100%;
          font-size: 14px;
          color: #141414;
        }

        .btn {
          width: 58px;
          height: 26px;
          background-color: #004098;
          border-radius: 13px;
          text-align: center;
          line-height: 26px;
          font-size: 12px;
          color: #fff;
        }

        .login {
          line-height: 54px;
        }
      }
    }

    .money {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 24px 0 0;
      box-sizing: border-box;


      .box {
        flex: 1;
        height: 50px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .txt1 {
          font-size: 12px;
          color: #222222;
        }

        .txt2 {
          display: inline-block;
          height: 25px;
          font-size: 14px;
          color: #FA2C19;
          font-weight: bold;
          line-height: 25px;
        }
      }
    }

    .money-line {
      border-bottom: 1px dashed #ECECEC;
      margin: 12px 0;

    }

    .other-box {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(auto-fill, 33.33%);
      justify-content: space-between;
      grid-row-gap: 10px;

      // margin-top: 20px;
      .other_item {
        width: 100%;
        height: 50px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
          width: 18px;
        }

        div {
          font-size: 12px;
          color: #444444;
          line-height: 17px;
          margin-top: 10px;
        }
      }
    }

    .line {
      width: 100%;
      height: 1px;
      border-top: 1px dashed #ECECEC;
      margin: 15px 0;
    }

    .box2 {
      width: 100%;

      .nav {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 6px;
        position: relative;
        box-sizing: border-box;

        &::before {
          content: "";
          width: 2px;
          height: 14px;
          background: linear-gradient(270deg, #FF7728 0%, #FF5B2A 100%);
          border-radius: 1px;
          position: absolute;
          left: 0;
          bottom: 0;
        }

        .nav-tit {
          font-size: 13px;
          font-weight: bold;
        }

        .nav-more {
          color: #999999;
          font-size: 12px;
        }
      }

      .center {
        width: 100%;
        margin-top: 10px;
        padding-left: 13px;
        box-sizing: border-box;
        position: relative;

        &::before {
          content: "";
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: #FA2C19;
          position: absolute;
          left: 1px;
          top: 6px;
        }

        .message {
          width: 100%;
          display: flex;
          align-items: center;
          // justify-content: flex-start;
          margin-top: 8px;
          padding-right: 20px;
          box-sizing: border-box;

          .lable {
            display: inline-block;
            width: 32px;
            height: 18px;
            background-color: #f8e8eb;
            text-align: center;
            line-height: 18px;
            font-size: 12px;
            color: #e60012;
          }

          .word {
            flex: 1;
            display: inline-block;
            font-size: 12px;
            color: #141414;
            margin-top: 5px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            word-break: break-all;
          }

          >img {
            width: 26px;
          }

          .word:first-child {
            margin-top: 0;
          }

          .word2 {
            flex: 1;
            display: inline-block;
            font-size: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 12;
            -webkit-box-orient: vertical;
            word-break: break-all;
          }
        }

        .message:first-child {
          margin-top: 0;
        }
      }
    }
  }
}
</style>